import React, { FC, ReactNode } from 'react';
import { Modal, Button } from 'antd';
import styles from './index.module.less';

interface Props {
  visible: boolean,
  changeVisible: (v: boolean) => void,
}

const str1 = '您好！报告与数据仅供腾讯内部使用，请严格遵守保密规定，勿私自转发、传播或分享给公司内外的其他团队。';
const str2 = '如有疑问或特殊需求，请联系ronsonhuang(黄润心)，感谢您的理解与支持！';

const TipsModal: FC<Props> = ({ visible, changeVisible }: Props) => (
  <Modal
    visible={visible}
    centered
    title={null}
    footer={null}
    forceRender
    modalRender={(modal: ReactNode) => (
      <div className={styles.tipsModal}>
        {modal}
      </div>
    )}
    bodyStyle={{
      width: '500px',
      height: '200px',
    }}
    maskStyle={{ zIndex: 1000000001 }}
    zIndex={1000000002}
  >
    <div className={styles.title}>提示</div>
    <div className={styles.textContent}>
      <div className={styles.text}>
        {`${str1}${str2}`}
      </div>
    </div>
    <Button
      type="primary"
      onClick={() => {
        changeVisible(false);
      }}
      className={styles.button}
    >
      知道了
    </Button>
  </Modal>
);

export default TipsModal;
